import { WriteRequest } from "~/backendApis/foundation/WriteRequest"

interface Params {
  universalCorporationId: string
  chatGroupId: string
  textMessage: string
}

export class SendMessageWriteRequest extends WriteRequest<void> {
  private readonly params: Params

  constructor(params: Params) {
    super()
    this.params = params
  }

  public post(): Promise<void> {
    const { textMessage } = this.params
    return this.apiClient.post(this.makeEndpoint(), { textMessage })
  }

  private makeEndpoint(): string {
    const { universalCorporationId, chatGroupId } = this.params
    return `/matching/corporation_member/${universalCorporationId}/chat_group/${chatGroupId}/message/create`
  }
}
